
export const unsortedPosters = [
    { src: '01-WebsiteFiles/Film Posters/2025, Jar of Time.webp', alt: 'Jar of Time (2025)', title: 'Jar of Time (2025)' },
    { src: '01-WebsiteFiles/Film Posters/2025, Mardazma.webp', alt: 'Mardazma (2025)', title: 'Mardazma (2025)' },
    { src: '01-WebsiteFiles/Film Posters/2025, Time Paradox.webp', alt: 'Time Paradox (2025)', title: 'Time Paradox (2025)', },
    { src: '01-WebsiteFiles/Film Posters/2024, DeadDreaming.webp', alt: 'Dead Dreaming (2024)', title: 'Dead Dreaming (2024)' },
    { src: '01-WebsiteFiles/Film Posters/2024, Low Budget Heist.webp', alt: 'Low Budget Heist (2024)', title: 'Low Budget Heist (2024)' },
    { src: '01-WebsiteFiles/Film Posters/2024, As Day Goes By.webp', alt: 'As Day Goes By (2024)', title: 'As Day Goes By (2024)' },
    { src: '01-WebsiteFiles/Film Posters/2024, Hilda Ha. Võrgust väljas.webp', alt: 'Hilda Ha. Võrgust väljas (2024)', title: 'Hilda Ha. Võrgust väljas (2024)' },
    { src: '01-WebsiteFiles/Film Posters/2024, ScreenMe Podcast.webp', alt: 'ScreenMe Podcast (2024)', title: 'ScreenMe Podcast (2024)' },
    { src: '01-WebsiteFiles/Film Posters/2023, 1000.webp', alt: '1000 (2023)', title: '1000 (2023)' },
    { src: '01-WebsiteFiles/Film Posters/2023, It\'s Like Summer.webp', alt: "It's Like Summer (2023)", title: "It's Like Summer (2023)" },
    { src: '01-WebsiteFiles/Film Posters/2022, Aina Jhyaalko Putali.webp', alt: 'Aina Jhyaalko Putali (2022)', title: 'Aina Jhyaalko Putali (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, Chiso Manche.webp', alt: 'Chiso Manche (2022)', title: 'Chiso Manche (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, Dokh.webp', alt: 'Dokh (2022)', title: 'Dokh (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, Into Oblivion.webp', alt: 'Into Oblivion (2022)', title: 'Into Oblivion (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, Kõne Taevast (Call of God).webp', alt: 'Kõne Taevast (Call of God) (2022)', title: 'Kõne Taevast (Call of God) (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, O Que Vemos.webp', alt: 'O Que Vemos (2022)', title: 'O Que Vemos (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, PaaniPhoto.webp', alt: 'PaaniPhoto (2022)', title: 'PaaniPhoto (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, Sana y Salva.webp', alt: 'Sana y Salva (2022)', title: 'Sana y Salva (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2022, The Silence of Banana Trees.webp', alt: 'The Silence of Banana Trees (2022)', title: 'The Silence of Banana Trees (2022)' },
    { src: '01-WebsiteFiles/Film Posters/2021, Adrishya Satta.webp', alt: 'Adrishya Satta (2021)', title: 'Adrishya Satta (2021)' },
    { src: '01-WebsiteFiles/Film Posters/2021, All Nighter.webp', alt: 'All Nighter (2021)', title: 'All Nighter (2021)' },
    { src: '01-WebsiteFiles/Film Posters/2021, Lukus.webp', alt: 'Lukus (2021)', title: 'Lukus (2021)' },
    { src: '01-WebsiteFiles/Film Posters/2021, Rua Da Solidão.webp', alt: 'Rua Da Solidão (2021)', title: 'Rua Da Solidão (2021)' },
    { src: '01-WebsiteFiles/Film Posters/2019, Aama.webp', alt: 'Aama (2019)', title: 'Aama (2019)' },
    { src: '01-WebsiteFiles/Film Posters/2019, Ama Khando.webp', alt: 'Ama Khando (2019)', title: 'Ama Khando (2019)' },
    { src: '01-WebsiteFiles/Film Posters/2019, Learning To Fly_edited.webp', alt: 'Learning To Fly (2019)', title: 'Learning To Fly (2019)' },
    { src: '01-WebsiteFiles/Film Posters/2018, 100 Rs.webp', alt: '100 Rs (2018)', title: '100 Rs (2018)' },
    { src: '01-WebsiteFiles/Film Posters/2018, Bare Trees in The Mist.webp', alt: 'Bare Trees in The Mist (2018)', title: 'Bare Trees in The Mist (2018)' },
    { src: '01-WebsiteFiles/Film Posters/2018, Mahanagar.webp', alt: 'Mahanagar (2018)', title: 'Mahanagar (2018)' },
    { src: '01-WebsiteFiles/Film Posters/2017, Chakkar.webp', alt: 'Chakkar (2017)', title: 'Chakkar (2017)' },
    { src: '01-WebsiteFiles/Film Posters/2016, Goodbye Kathmandu.webp', alt: 'Goodbye Kathmandu (2016)', title: 'Goodbye Kathmandu (2016)' },
    { src: '01-WebsiteFiles/Film Posters/2016, KTM CockTale.webp', alt: 'KTM CockTale (2016)', title: 'KTM CockTale (2016)' },
    { src: '01-WebsiteFiles/Film Posters/2016, Ncell Axiata_edited.webp', alt: 'Ncell Axiata (2016)', title: 'Ncell Axiata (2016)' },
    { src: '01-WebsiteFiles/Film Posters/2016, Pahunch.webp', alt: 'Pahunch (2016)', title: 'Pahunch (2016)' },
    { src: '01-WebsiteFiles/Film Posters/2016, Phulsiri.webp', alt: 'Phulsiri (2016)', title: 'Phulsiri (2016)' },
    { src: '01-WebsiteFiles/Film Posters/2014, Ritu.webp', alt: 'Ritu (2014)', title: 'Ritu (2014)' },
    { src: '01-WebsiteFiles/Film Posters/2011, Ma Khushi Chu.webp', alt: 'Ma Khushi Chu (2011)', title: 'Ma Khushi Chu (2011)' },
];

export const servicesData = [
    {
        icon: '🎵',
        title: 'Sound Design',
        text: 'Creating compelling sonic landscapes that enhance storytelling and elevate emotional impact across various media.'
    },
    {
        icon: '🎼',
        title: 'Music Composition',
        text: 'Composing original scores and musical pieces that resonate with audiences and define unique artistic visions.'
    },
    {
        icon: '🎛️',
        title: 'Technical Audio',
        text: 'Proficient in audio implementation, mixing, and mastering, ensuring pristine sound quality and seamless integration.'
    }
];

export const experienceHighlights = [
    {
        title: 'Immersive Sound Worlds',
        description: 'Layered spatial mixes, generative textures, and field recordings woven together for cinema and experiential installations.',
        metric: '150+ Films, Documentaries, and Music projects'
    },
    {
        title: 'Dynamic Music Systems',
        description: 'Adaptive scores and interactive stems that react to story beats, physics events, and live performance cues.',
        metric: 'Realtime scoring pipelines'
    },
    {
        title: 'Precision Delivery',
        description: 'From Dolby Atmos masters to festival-ready DCP assets, every deliverable is tuned for pristine playback.',
        metric: 'Global festival premieres'
    }
];
